export default __webpack_public_path__ + "static/media/add-circle.c94b2e99.svg";